module.exports = __webpack_public_path__ + "img/TZS09647.3fb63cae.jpeg";